module.exports = __webpack_public_path__ + "static/media/kw.a086ea4d.svg";